export default "assets/images/icons/facebook-2bbd64dd.svg";